import React from "react";
import { IconTextLink } from "component-library";

import "./StepsPagination.scss";

export interface IStepsPaginationProps {
  moveToPrev: () => void;
  moveToNext: () => void;
  previousButtonText: string;
  nextButtonText: string;
  isPrevStepAvailable: boolean;
  isNextStepAvailable: boolean;
}

export const StepsPagination: React.FC<
  React.PropsWithChildren<IStepsPaginationProps>
> = (props) => {
  const {
    moveToPrev,
    moveToNext,
    previousButtonText,
    nextButtonText,
    isPrevStepAvailable,
    isNextStepAvailable,
  } = props;

  return (
    <div className="c-steps-pagination">
      {isPrevStepAvailable && (
        <div className="c-steps-pagination__navigation-item left">
          <IconTextLink
            variant="primary"
            iconName="icon-chevroncircle"
            text={previousButtonText}
            handleClick={moveToPrev}
          />
        </div>
      )}
      {isNextStepAvailable && (
        <div className="c-steps-pagination__navigation-item right">
          <IconTextLink
            variant="primary"
            reverseOrder={true}
            iconName="icon-chevroncircle"
            text={nextButtonText}
            handleClick={moveToNext}
          />
        </div>
      )}
    </div>
  );
};
